import React from 'react'
import CvTemplate from '../CvTemplate'

const CvEnWordpress = () => {
	return (
		<CvTemplate
			name="Recu Daniel"
			age={33}
			city="București"
			phone="+40 748 702 852"
			email="recudaniel@yahoo.com"
			website="https://webackit.com"
			linkedin="https://www.linkedin.com/in/daniel-recu"
			github="https://github.com/recuDaniel"
			aboutMe="I help companies automate workflows, scale WordPress platforms, and optimize SaaS delivery - combining 12+ years of coding, AI automation, and infrastructure experience. Specialist in WordPress custom architecture, React.js applications, Python automation, AI integrations, and DevOps."
			strengths={[
				'Advanced WordPress architecture - custom themes, 100+ plugins, 50+ Gutenberg blocks',
				'Automation expert - 200+ platforms automated (social media, blogs, marketplaces)',
				'Personal advanced trading bot - Binance API, Python',
				'Proven expertise in scaling WooCommerce and SaaS platforms'
			]}
			skillsData={[
				{
					category: 'Frontend',
					skills: 'WordPress (custom themes & plugins), Gutenberg, React.js, HTML5, CSS3, JavaScript, TypeScript'
				},
				{
					category: 'Backend',
					skills: 'PHP (advanced), Python (automation), Node.js, REST API, SQL, WooCommerce'
				},
				{
					category: 'DevOps & Infrastructure',
					skills: 'Nginx, Docker, CI/CD (GitHub Actions), DigitalOcean, Cloudflare, Linux server administration (basic), AWS (EC2, S3 basic)'
				},
				{ category: 'Database', skills: 'MySQL, MariaDB, Redis' },
				{
					category: 'AI & Automation',
					skills: 'GPT-4 API integration, Python automation, Selenium, SikuliX, automation of 200+ web platforms (social media, blogs, marketplaces), Binance API trading bot'
				},
				{
					category: 'Design & SEO',
					skills: 'Adobe Creative Suite, Figma, SEO optimization, page speed optimization'
				}
			]}
			projects={[
				{
					title: 'On-Subscription Platform',
					description:
						'Founder and lead developer of on-subscription.com - SaaS platform with WordPress backend, React dashboards, automation, CRM, and client portal.'
				},
				{
					title: 'Custom WordPress Framework',
					description:
						'Built custom theme + 50 Gutenberg blocks + extended native blocks. Modular design system used in 100+ client projects.'
				},
				{
					title: 'Plugin Development',
					description:
						'Created 100+ plugins - WooCommerce, SEO automation, AI content tools, performance/security enhancements.'
				},
				{
					title: 'WooCommerce Data Automation',
					description:
						'Automated integration of 80GB external DB into WooCommerce with sub-1 sec load times via advanced SQL + Python automation.'
				},
				{
					title: 'AI & Automation',
					description:
						'200+ automation tools for social media, blogs, marketplaces. Automated user registration, posting, GPT-4 content generation. Binance Python trading bot project.'
				},
				{
					title: 'CI/CD & Infrastructure',
					description:
						'Dockerized WordPress, GitHub Actions, Nginx tuning, AWS & DigitalOcean deployments.'
				}
			]}
			workHistory={[
				{
					title: 'Digital Solutions Architect & Founder',
					company: 'Webackit Solutions S.R.L.',
					period: 'July 2021 - Present',
					description:
						'Founder. Built On-Subscription platform, 200+ automation tools, plugins, SaaS products. Managed full DevOps delivery.',
					techStack:
						'WordPress, PHP, React.js, Python, Docker, Nginx, AWS, DigitalOcean, MySQL'
				},
				{
					title: 'Senior React Developer',
					company: 'iNoRisk GmbH & Co. KG',
					period: 'Jan 2022 - Apr 2025',
					description:
						'React developer for enterprise finance systems. Modular components, MobX state management.',
					techStack: 'React.js, MobX, TailwindCSS, GitHub Actions'
				},
				{
					title: 'Senior Software Developer',
					company: 'Extendstudio',
					period: 'Jan 2022 - Mar 2023',
					description:
						'Developed advanced WP plugin systems with React, Gutenberg blocks, admin panels.',
					techStack: 'WordPress, React.js, PHP, Gutenberg, REST API'
				},
				{
					title: 'Senior Software Developer',
					company: 'TPC Management SRL',
					period: 'Apr 2019 - May 2021',
					description:
						'Full-stack developer for React Native apps and WordPress platforms.',
					techStack:
						'React Native, React.js, WordPress, PHP, REST API'
				},
				{
					title: 'Web Developer',
					company: 'LtvStudio',
					period: 'Feb 2016 - Nov 2018',
					description:
						'Developed responsive WP sites. UI components, animations, SEO optimization.',
					techStack: 'WordPress, HTML5, CSS3, JavaScript'
				},
				{
					title: 'Web Designer & Developer',
					company: 'Metropolitan Residence',
					period: 'May 2015 - Feb 2016',
					description:
						'Designed and developed WordPress marketing sites.',
					techStack:
						'WordPress, PHP, HTML5, CSS3, Adobe Creative Suite'
				},
				{
					title: 'Marketing & SEO Assistant',
					company: 'ROPLAST INSTAL DISTRIBUTION',
					period: 'Mar 2014 - Apr 2015',
					description:
						'SEO optimization, page performance improvements.',
					techStack: 'WordPress, HTML, CSS, SEO tools'
				}
			]}
			education={[
				{
					title: 'MSc Computer Science with AI',
					institution: 'Keele University, UK',
					period: '2023 - 2025 (in progress)',
					details:
						'Machine learning (SVM, decision trees), Jupyter/Pandas, AI ethics, automation systems. Personal Binance Python bot project.'
				},
				{
					title: 'Certified Web Designer',
					institution: 'Link Academy',
					period: '2013 - 2014',
					details: 'HTML, CSS, JS, PHP, Adobe Suite.'
				},
				{
					title: 'Arts High School (Nicolae Tonitza)',
					institution: 'Bucharest',
					period: '2007 - 2011',
					details: 'Visual arts, design thinking.'
				}
			]}
			languages={['Romanian (native)', 'English (advanced)']}
			availability={['Full-time', 'Project-based', 'Remote']}
			sectionsMarginTop={{
				about: 30,
				strengths: 15,
				skills: 15,
				workHistory: 60,
				education: 0
			}}
		/>
	)
}

export default CvEnWordpress
